<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>实验室概况</h1>
        <p>了解我们的历史、使命和研究方向</p>
      </div>
    </div>

    <!-- 上半部分：团队主任联系方式 + 实验室简介 -->
    <div class="main-content">
      <div class="about-container">
        <div class="contact-info">
          <h3 class="contact-title">团队主任联系方式</h3>
          <div class="contact-item">
            <span class="contact-label">姓名：</span>
            <span>范教授</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">职称：</span>
            <span>教授/博士生导师</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">电话：</span>
            <span>XXX-12345678</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">邮箱：</span>
            <span>director@xxx-lab.edu.cn</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">办公室：</span>
            <span>科研楼A座501室</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">办公时间：</span>
            <span>周一至周五 9:00-17:00</span>
          </div>
        </div>

        <div class="about-intro">
          <h2>实验室简介</h2>
          <p v-for="item in intro" :key="item">{{ item }}</p>
        </div>
      </div>
    </div>

    <!-- 下半部分：研究方向 + 研究平台 -->
    <div class="research-section">
      <div class="research-tabs">
        <div
          class="research-tab"
          :class="{ active: activeTab === 'directions' }"
          @click="activeTab = 'directions'">
          研究方向
        </div>
        <div
          class="research-tab"
          :class="{ active: activeTab === 'platforms' }"
          @click="activeTab = 'platforms'">
          研究平台
        </div>
      </div>

      <!-- 研究方向 -->
      <div class="research-content" v-show="activeTab === 'directions'">
        <div class="research-directions">
          <p>实验室致力人工智能与机器人的研究与应用，主要研究方向包括：</p>
          <div class="direction-list">
            <div
              class="direction-item"
              v-for="(d, idx) in directions"
              :key="idx"
              @click="openPlatform(d)">
              <div class="direction-link">
                <h3 class="direction-title">{{ d.title }}</h3>
                <p>{{ d.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 研究平台 -->
      <div class="research-content" v-show="activeTab === 'platforms'">
        <div class="research-platforms">
          <p>实验室拥有完善的材料制备、表征和性能测试平台：</p>
          <div class="platform-list">
            <div
              class="platform-item"
              v-for="(p, idx) in platforms"
              :key="idx"
              @click="openPlatform(p)">
              <h3 class="platform-title">{{ p.title }}</h3>
              <p>{{ p.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台弹窗 -->
    <div class="modal-overlay" v-if="modalActive" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <h3 class="modal-title">{{ selectedPlatform.title }}</h3>
          <button class="modal-close" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <p>{{ selectedPlatform.desc }}</p>
          <div class="modal-results"></div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import { GetAboutData } from "../../api/about";

export default {
  name: "AboutPage",
  components: { Header, Nav, Footer },
  data() {
    return {
      intro: [],
      labLogo: "lab-logo.png",
      uestcLogo: "uestc-logo.png",
      uestcSzLogo: "uestc-sz-logo.png",
      defaultLogo: defaultLogo,
      activeTab: "directions",
      directions: [],
      platforms: [],
      modalActive: false,
      selectedPlatform: {},
    };
  },
  methods: {
    setDefaultLogo(event) {
      // 与首页一致的实现：当图片加载失败时，替换为 defaultLogo
      event.target.src = defaultLogo;
    },
    openPlatform(platform) {
      this.selectedPlatform = platform;
      this.modalActive = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.modalActive = false;
      this.selectedPlatform = {};
      document.body.style.overflow = "";
    },
    async getIntroData() {
      let category = {
        category: "intro",
      };
      let res = await GetAboutData(category);
      if (res.code === 0) {
        this.intro = res.rows[0].descriptionsArr;
      }
    },
    async getDirectionData() {
      let category = {
        category: "direction",
      };
      let res = await GetAboutData(category);
      if (res.code === 0) {
        let directiondata = res.rows;
        for (let i = 0; i < directiondata.length; i++) {
          this.directions.push({
            title: directiondata[i].title,
            desc: directiondata[i].description,
          });
        }
      }
    },
    async getPlatformData() {
      let category = {
        category: "platform",
      };
      let res = await GetAboutData(category);
      if (res.code === 0) {
        let platformdata = res.rows;
        for (let i = 0; i < platformdata.length; i++) {
          this.platforms.push({
            title: platformdata[i].title,
            desc: platformdata[i].description,
          });
        }
      }
    },
  },
  mounted() {
    this.getIntroData();
    this.getDirectionData();
    this.getPlatformData();
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

/* ==================== 上半部分主体内容 ==================== */
.main-content {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 20px;
}
.about-container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: flex-start;
}
.contact-info {
  flex: 1 1 250px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.contact-title {
  color: #004080;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 2px solid #004080;
  padding-bottom: 10px;
}
.contact-item {
  margin-bottom: 15px;
}
.contact-label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #004080;
}
.about-intro {
  flex: 2 1 600px;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.06);
}

.about-intro h2 {
  color: #003366;
  font-size: 1.8em;
  margin-bottom: 20px;
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
}

.about-intro p {
  margin-bottom: 1rem;
}

/* ==================== 下半部分：研究方向 + 平台 ==================== */
.research-section {
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  background: #f7f8fa;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* tabs */
.research-tabs {
  display: flex;
  justify-content: center; /* 居中 tab */
  gap: 20px; /* tab 间距 */
  margin-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}
.research-tab {
  padding: 8px 16px;
  cursor: pointer;
  color: #666;
  font-weight: bold;
  transition: color 0.3s, border-bottom 0.3s;
  border-bottom: 3px solid transparent;
}
.research-tab.active {
  color: #004080;
  border-bottom-color: #004080;
}

/* 研究方向 */
.direction-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}
.research-directions,
.research-platforms {
  text-align: center;
}

.research-directions p,
.research-platforms p {
  margin: 1rem 0;
}

.direction-item {
  background: #fff;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.direction-item h3 {
  transition: color 0.3s ease;
}
.direction-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.direction-item:hover h3 {
  color: #ffd700; /* 标题黄色 */
}
/* 研究平台 */
.platform-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}
.platform-item {
  background: #fff;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.platform-item img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 6px;
}
.platform-item h3 {
  transition: color 0.3s ease;
}
.platform-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.platform-item:hover h3 {
  color: #ffd700; /* 标题黄色 */
}

/* ==================== 模态框 ==================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-container {
  background: #fff;
  width: 90%;
  max-width: 820px;
  border-radius: 8px;
  overflow: hidden;
}
.modal-header {
  background: #003366;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  padding: 20px;
}
.modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

/* ==================== 响应式 ==================== */
@media (max-width: 768px) {
  .about-container {
    flex-direction: column;
  }
  .research-section {
    padding: 15px;
  }
}
</style>
